import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";
import TitleWrapper from "../../../../../components/ui/titlewrapper/TitleWrapper";

const initState = {
    sessions: '',
    scheduleDate: '',
    qty: '',
    seatbooked: '',
    startAt: '',
    endAt: '',
    howToGetThere: '',
    address: ''

};

export const SessionEditFormData = {
    name: "EditSessionFormData",
    initialState: initState,
    section: [
        {
            title: "Edit Session Time Slot Section",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },
            fields: [
                {
                    id: "sessions",
                    label: "Session",
                    Field_Name: "Session",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sessions",
                    fieldSetting: {
                        placeholder: "Session Name",
                        allowSpace: true,
                        options: [],
                        isDisable: true,
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-12 mb-2 custom-validation",
                    },
                },
                {
                    id: "scheduleDate",
                    label: "Schedule Date",
                    Field_Name: "Schedule Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "scheduleDate",
                    fieldSetting: {
                        allowSpace: true,
                        options: [],
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-12 mb-2 custom-validation",
                    },
                },
                {
                    id: "qty",
                    label: "Qty",
                    Field_Name: "Qty",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "qty",
                    fieldSetting: {
                        placeholder: "Qty",
                        allowSpace: true,
                        options: [],
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-12 mb-2 custom-validation",
                    },
                },
                {
                    id: "seatbooked",
                    label: "Seat booked",
                    Field_Name: "Seat booked",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "seatbooked",
                    fieldSetting: {
                        placeholder: "Seat booked",
                        allowSpace: true,
                        options: [],
                        isDisable: true,
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-12 mb-2 custom-validation",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",

                    style: {
                        containerCss: "col-lg-3 col-md-4 blank-field blank-field-with-btn",
                    },
                },
                {
                    id: "startAt",
                    label: "",
                    Field_Name: "startAt",
                    fieldType: FormFieldTypes.TIMEPICKER,
                    dataField: "startAt",
                    fieldSetting: {
                        allowSpace: true,
                        options: [],
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-12 mb-2 custom-validation",
                    },
                },
                {
                    id: "endAt",
                    label: "",
                    Field_Name: "endAt",
                    fieldType: FormFieldTypes.TIMEPICKER,
                    dataField: "endAt",
                    fieldSetting: {
                        allowSpace: true,
                        options: [],
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-3 col-md-12 mb-2 custom-validation",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",

                    style: {
                        containerCss: "col-lg-3 col-md-4 blank-field blank-field-with-btn",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",

                    style: {
                        containerCss: "col-lg-3 col-md-4 blank-field blank-field-with-btn",
                    },
                },
                {
                    id: "howToGetThere",
                    label: "How to get there",
                    Field_Name: "How to get there",
                    fieldType: FormFieldTypes.TEXTEDITOR,
                    dataField: "howToGetThere",
                    fieldSetting: {
                        allowSpace: true,
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-xxl-4 col-xl-12 col-md-12 col-12 mt-2",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",

                    style: {
                        containerCss: "col-lg-3 col-md-4 blank-field blank-field-with-btn",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",

                    style: {
                        containerCss: "col-lg-3 col-md-4 blank-field blank-field-with-btn",
                    },
                },
                {
                    id: "address",
                    label: "Address",
                    Field_Name: "Address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "address",
                    fieldSetting: {
                        placeholder: "Address",
                        allowSpace: true,
                        options: [],
                    },
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-12 custom-validation",
                    },
                },
            ],
        },
    ],
}